import { Phone } from "lucide-react";
import { PHONE_DISPLAY, PHONE_HREF } from "@/data/site";
import { scrollTo } from "./Reveal";

const LINKS = [
  { label: "Início", hash: "#inicio" },
  { label: "Serviços", hash: "#servicos" },
  { label: "Sobre Nós", hash: "#sobre" },
  { label: "Galeria", hash: "#galeria" },
  { label: "Contato", hash: "#contato" },
];

export const Footer = () => (
  <footer data-testid="footer-section" className="bg-stone-950 text-stone-300">
    <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12 py-16">
      <div className="grid md:grid-cols-3 gap-10 items-start">
        <div>
          <div className="flex items-center gap-3">
            <span className="w-10 h-10 rounded-full bg-[#C2185B] text-white font-serif-display italic text-lg flex items-center justify-center">
              EB
            </span>
            <span className="font-serif-display text-xl font-semibold text-white">
              Espaço da Beleza
            </span>
          </div>
          <p className="mt-4 font-serif-display italic text-lg text-[#F8BBD0]">
            Realce sua beleza ♡ Revele sua essência
          </p>
        </div>

        <nav>
          <p className="text-xs tracking-[0.25em] uppercase text-stone-500 mb-4">Menu</p>
          <ul className="space-y-2.5">
            {LINKS.map((l) => (
              <li key={l.hash}>
                <button
                  onClick={() => scrollTo(l.hash)}
                  className="text-sm hover:text-[#F8BBD0] transition-colors duration-300"
                >
                  {l.label}
                </button>
              </li>
            ))}
          </ul>
        </nav>

        <div>
          <p className="text-xs tracking-[0.25em] uppercase text-stone-500 mb-4">
            Agendamentos
          </p>
          <a
            data-testid="footer-phone-link"
            href={PHONE_HREF}
            className="inline-flex items-center gap-3 font-serif-display text-3xl font-semibold text-white hover:text-[#F8BBD0] transition-colors duration-300"
          >
            <Phone size={20} className="text-[#C2185B]" />
            {PHONE_DISPLAY}
          </a>
          <p className="mt-3 text-sm text-stone-400">
            Terça a Sábado · 09:00–13:00 e 15:00–18:00
          </p>
          <p className="text-sm text-stone-500">Fechado aos Domingos e Segundas</p>
        </div>
      </div>

      <div className="mt-12 pt-8 border-t border-stone-800 flex flex-col sm:flex-row justify-between gap-3 text-xs text-stone-500">
        <p>© {new Date().getFullYear()} Espaço da Beleza. Todos os direitos reservados.</p>
        <p>Estética · Unhas · Sobrancelhas · Depilação</p>
      </div>
    </div>
  </footer>
);
